import { getGiftById, createGift, getAllGifts, updateGift, deleteGift } from '../../services/wheel.api'

const state = {
  items: []
}

const getters = {
  gifts: (state) => {
    return state.items
  },
  getGiftsById: (state) => (id) => {
    return state.items.find(item => (item.id === id))
  }
}

// actions
const actions = {
  async loadGifts ({ commit, rootGetters }, wheelId) {
    let sitekey = rootGetters['account/currentSitekey']

    const gifts = await getAllGifts(sitekey, wheelId)
    commit('RESET_GIFT_ITEMS')
    commit('ADD_GIFT_ITEMS', { items: gifts })
    return gifts
  },

  async loadGiftById ({ commit, rootGetters }, { id }, wheelId) {
    let sitekey = rootGetters['account/currentSitekey']

    const gift = await getGiftById(sitekey, wheelId, id)
    commit('UPDATE_GIFT_ITEM', { item: gift })
    return gift
  },

  resetGifts ({ commit }) {
    return new Promise((resolve) => {
      commit('RESET_GIFT_ITEMS')
      resolve()
    })
  },

  async addGift ({ commit, rootGetters }, data) {
    const sitekey = rootGetters['account/currentSitekey']

    const newGift = await createGift(sitekey, data.wheelId, data.gift)
    commit('ADD_GIFT_ITEM', { item: newGift })
    return newGift
  },

  async changeGift ({ commit, rootGetters }, data) {
    const sitekey = rootGetters['account/currentSitekey']

    const newGift = await updateGift(sitekey,  data.wheelId, data.gift)
    commit('UPDATE_GIFT_ITEM', { item: newGift })
    return newGift
  },

  async removeGift ({ commit, rootGetters }, data) {
    const sitekey = rootGetters['account/currentSitekey']

    await deleteGift(sitekey, data.wheelId, data.gift)
    commit('REMOVE_GIFT_ITEM', { item: gift })
  },
}

// mutations
const mutations = {
  ADD_GIFT_ITEMS (state, { items }) {
    state.items.push(...items)
  },

  ADD_GIFT_ITEM (state, { item }) {
    state.items.push(item)
  },

  RESET_GIFT_ITEMS (state) {
    state.items = []
  },

  UPDATE_GIFT_ITEM (state, { item }) {
    let find = false

    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        Object.assign(state.items[i], item)
        find = true
      }
    }

    if (!find) {
      state.items.push(item)
    }
  },

  REMOVE_GIFT_ITEM (state, { item }) {
    let index = state.items.findIndex(i => i.id === item.id)
    if (index !== -1) {
      state.items.splice(index, 1)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/gifts.js